import { createContextPart } from "../create-context-part.js";
import { useSliderContext } from "./context.js";
//#region src/ui/slider/buffer.tsx
/** Displays the buffered range on the slider track. */
const SliderBuffer = createContextPart({
	displayName: "SliderBuffer",
	tag: "div",
	useContext: useSliderContext
});
//#endregion
export { SliderBuffer };

//# sourceMappingURL=buffer.js.map